const ITEMS = [
  "Sewa Steger",
  "Jual Steger",
  "Main Frame",
  "Cross Brace",
  "Catwalk",
  "U-Head Jack",
  "Base Jack",
  "Joint Pin",
  "Diantar ke Lokasi Proyek",
  "Kualitas Terjaga",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-tech whitespace-nowrap px-8 text-xs uppercase tracking-[0.28em] text-white/70">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-[#DF9F00]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="tech-marquee"
    className="relative overflow-hidden border-y border-white/10 bg-[#0F1115] py-5"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
